import { PRODUCT_RELATED, type RelatedProductsState } from '../constants/product'
import { pickRelatedProducts, storefrontProducts } from '../helpers/catalog'
import { mapProductCard, type ProductViewModel } from '../helpers/mapCatalog'
import { useStorefrontCatalog } from './useStorefrontCatalog'

export function useRelatedProducts(
  product: ProductViewModel | null,
): RelatedProductsState {
  const { catalog, loading, error } = useStorefrontCatalog()
  const rows = catalog ? storefrontProducts(catalog) : []
  const products =
    product && catalog
      ? pickRelatedProducts(rows, product, PRODUCT_RELATED.limit).map(mapProductCard)
      : []

  return {
    products,
    loading: Boolean(product) && loading && !catalog && !error,
  }
}
